import React from 'react';
import { Loader2 } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

interface SettingsLayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  isLoading?: boolean;
  isSaving?: boolean;
  onSave?: () => void;
  saveDisabled?: boolean;
  className?: string;
}

export function SettingsLayout({
  children,
  title,
  description,
  isLoading,
  isSaving,
  onSave,
  saveDisabled = false,
  className
}: SettingsLayoutProps) {
  return (
    <div className={twMerge('max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6', className)}>
      {/* Header */}
      {(title || description || onSave) && (
        <div className="md:flex md:items-center md:justify-between mb-6">
          <div className="min-w-0 flex-1">
            {title && (
              <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
                {title}
              </h2>
            )}
            {description && (
              <p className="mt-1 text-sm text-gray-500">
                {description}
              </p>
            )}
          </div>
          {onSave && (
            <div className="mt-4 flex md:ml-4 md:mt-0">
              <button
                type="button"
                onClick={onSave}
                disabled={saveDisabled || isSaving}
                className={twMerge(
                  'inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500',
                  (saveDisabled || isSaving) ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700',
                )}
              >
                {isSaving && (
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                )}
                Enregistrer
              </button>
            </div>
          )}
        </div>
      )}

      {/* Main content */}
      <div className="bg-white shadow rounded-lg">
        {isLoading ? (
          <div className="flex items-center justify-center h-32">
            <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
          </div>
        ) : (
          <div className="p-6">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}

export default SettingsLayout;
